import secureLocalStorage from "react-secure-storage";

export const getColorMode = () => (dispatch) => {
  try {
    const mode =
      JSON.parse(secureLocalStorage.getItem("mode"))?.mode || "light";
    dispatch({ type: "GET_MODE", payload: mode });
  } catch (error) {
    console.error("Failed to get mode from localStorage:", error);
  }
};

export const setColorMode = (mode) => (dispatch) => {
  try {
    secureLocalStorage.setItem("mode", JSON.stringify({ mode }));
    dispatch({ type: "SET_MODE", payload: mode });
  } catch (error) {
    console.error("Failed to set mode in localStorage:", error);
  }
};
